import React, { useEffect, useState } from "react";
import { ImageBackground, View } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { logError } from "../../redux/actions/Ladger";
import { popAction, replaceAction } from "../../helpers/navigationHelpers";
import getPlatformType, { getImage } from "../../helpers/getPlatform";
import BackGroundGenerator from "../LandingPages/common/BackGroundGenerator";
import ODSButton from "../../../openbrix-design-system/ui/atoms/ODSButton";
import ReportsForm from "../../../openbrix-design-system/ui/molecules/Report/ReportsForm";
import FilePicker from "../../commonComponents/filePicker/filepicker";
import { ODSText } from "../../../openbrix-design-system/ui/atoms/ODSText";
import DropDownPicker from "../../commonComponents/DropDownPicker.web";
import { getTokens } from "../../../openbrix-design-system/design-tokens/color-tokens";
import { TenantService } from "../openFlow/openFlowRedux/tenant.service";
import { formatDate } from "../../helpers/functionHelpers";
import { types } from "../../redux/actionTypes";
import { navigate } from "../../navigation/RootNavigation";
import DatePickerComponent from "../../commonComponents/datepicker/DatePickerComponent.web";

const layoutType = getPlatformType();

const ReportIssue = (props) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.authReducer.profile);
  const [roomTypes, setRoomTypes] = useState([]);
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");

  const [descriptionText, setDescriptionText] = useState("");
  const [issueImages, setIssueImages] = useState([]); // multiple files
  const [dateOpened, setDateOpened] = useState(new Date());
  const [showNodata, setShowNodata] = useState(false);
  const [roomTypesVal, setRoomTypesVal] = useState(null);
  const [categoryTypesVal, setCategoryTypesVal] = useState(null);
  const [roomTypeError, setRoomTypeError] = useState("");
  const [categoryTypeError, setCategoryTypeError] = useState("");

  console.log("props", props)
  useEffect(() => {
    fetchData();
    setType(props?.route?.params?.type)
  }, [props?.route?.params?.id]);

  useEffect(() => {
if(props?.route?.params?.maintainance_id){
  setType('edit')
  fetchMaintainanceData(props?.route?.params?.maintainance_id)
}
    // if(props?.route?.params?.item){

    // }
  }, [props?.route?.params?.maintainance_id]);
  const fetchMaintainanceData = async (maintainance_id) => {
    try {
      const [mainTainanceData] = await Promise.all([
        TenantService.getMaintainanceDetails(maintainance_id),
      ]);
      if(mainTainanceData?.data?.open_flow_maintenance_issue_id){
        let prefilledDta = mainTainanceData?.data
        setTitle(prefilledDta?.title|| "")
        setDescriptionText(prefilledDta?.description|| "")
        setRoomTypesVal(prefilledDta?.room_type_id|| "")
        setCategoryTypesVal(prefilledDta?.category_id|| "")
        setDateOpened(prefilledDta?.date_opened)
        setIssueImages([...prefilledDta.images])
      }
      
    } catch (err) {
      console.log("Error fetching maintenance lists:", err);
    }
  };
  const fetchData = async () => {
    try {
      const [roomsRes, categoriesRes] = await Promise.all([
        TenantService.getRoomTypes(),
        TenantService.getCatogoriesTypes(),
      ]);

      setRoomTypes(roomsRes?.data?.data || []);
      setCategoryTypes(categoriesRes?.data?.data || []);
      console.log("roomsRes", roomsRes)
      console.log("categoriesRes", categoriesRes)

    } catch (err) {
      console.log("Error fetching maintenance lists:", err);
    }
  };
  const handleSubmit = async() => {
    console.log("setRoomTypeError",roomTypesVal)
    let isValid = true;
    // Room Type validation
    if (!roomTypesVal ||roomTypesVal =="Please select room type" ) {
      setRoomTypeError("Please select a room type");
      isValid = false;
    } else {
      setRoomTypeError("");
    }

    // Category Type validation
    if (!categoryTypesVal||categoryTypesVal =="Please select category type") {
      setCategoryTypeError("Please select a category type");
      isValid = false;
    } else {
      setCategoryTypeError("");
    }

    if (!isValid) return; // ❌ Stop submit

    // ✅ Continue existing submit logic
    if (profile?.data?.appUser?.app_user_id) {
      const imageUrls = issueImages
      if(type=='edit'){
        const Payload = {
          app_user_id: profile?.data?.appUser?.app_user_id,
          property_id: profile?.data?.tenantDetails?.property_id,
          openflow_id: props?.route?.params?.id,
          title: title,
          description: descriptionText,
          date_opened: dateOpened,
          images: imageUrls,
          room_type_id: roomTypesVal,
          category_id: categoryTypesVal,
        }

        const updateRespose = await TenantService.updateMaintainanceDetails(Payload,props?.route?.params?.maintainance_id);
        console.log("updateRespose",updateRespose)
        if(updateRespose.status){
          dispatch({
            type: types.SHOW_ALERT,
            alertType: "success",
            text: "Maintainance request updated successfully!",
          });
          popAction(props.navigation)
        }else{

          dispatch({
            type: types.SHOW_ALERT,
            alertType: "error",
            text:updateRespose?.message?updateRespose.message: "Something went wrong!",
          });
        }
      }else{
        dispatch(
          logError(
            {
              app_user_id: profile?.data?.appUser?.app_user_id,
              property_id: profile?.data?.tenantDetails?.property_id,
              openflow_id: props?.route?.params?.id,
              title: title,
              description: descriptionText,
              date_opened: dateOpened,
              images: imageUrls,
              room_type_id: roomTypesVal,
              category_id: categoryTypesVal,
            },
            props.navigation
          )
        );
      }

    } else {
      setShowNodata(true);
    }
  };

  const handleFileSelect = (files) => {
    console.log("imageUrls",files)

    setIssueImages((prev) => [...prev, files.openbrixName]);
  };
  const RenderFileicper = () => {
    return (
      <FilePicker
        width="100%"
        multiple={true}
        accept="image/*,video/*"
        onFileSelect={handleFileSelect}
      />
    )
  }
  console.log("dateOpened", dateOpened)
  const themeObj = getTokens('light').colors;
  const renderRoomDropDown = () => {
    return (
      <View
        style={{
          marginBottom: 10,
          width: '100%',
        }}
      >
        <ODSText
          type="sm-bold"
          color={themeObj.text['primary']}
          paddingVertical={4}
        >
          Room Type
        </ODSText>
        <DropDownPicker
          items={roomTypes.map((salutation) => {
            return { value: salutation?.open_flow_maintenance_issue_room_type_id, label: salutation.name };
          })}
          id="openflo-Title"
          placeholder="Please select room types"
          defaultValue={roomTypesVal}
          onChangeItem={(e) => {
            setRoomTypesVal(e.value);
          }}
          dropDownStyle={{ backgroundColor: 'white' }}
          zIndex={1001}

        />

        {roomTypeError ? (
          <ODSText
            paddingVertical={10}
            type="xs"
            color={themeObj.feedback.error[700]}
          >
            {roomTypeError}
          </ODSText>
        ) : null}
      </View>
    )
  }
  const renderCatogroriesDropDown = () => {
    return (
      <View
        style={{
          marginBottom: 10,
          width: '100%',
        }}
      >
        <ODSText
          type="sm-bold"
          color={themeObj.text['primary']}
          paddingVertical={4}
        >
          Categories Type
        </ODSText>
        <DropDownPicker
          items={categoryTypes.map((salutation) => {
            return { value: salutation.open_flow_maintenance_issue_category_id, label: salutation.name };
          })}
          id="openflo-Title"
          placeholder="Please select category type"
          defaultValue={categoryTypesVal}
          onChangeItem={(e) => {
            setCategoryTypesVal(e?.value);
          }}
          dropDownStyle={{ backgroundColor: 'white' }}
          zIndex={1001}

        />
        {categoryTypeError ? (
          <ODSText
            paddingVertical={10}
            type="xs"
            color={themeObj.feedback.error[700]}
          >
            {categoryTypeError}
          </ODSText>
        ) : null}
      </View>
    )
  }
  const RenderDatePicker =()=>{
    return(
      <DatePickerComponent
      key="datepicker"
      boxStyle={{  width: '100%',
        height: 44,
        borderWidth: 1,
        justifyContent: 'center',
        padding: 5,
        borderColor: '#d0d0d0',
        borderRadius: 5,
        display: 'flex',
        backgroundColor:"rgb(249, 250, 251)",
        marginTop:12}}
      id={"TDS-TENANCY-ENDDATE"}
      placeholder="Select a date"
      inputLabel={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}
      value={dateOpened}
      disabled={true}
      onUpdateInput={(date) => {
        setDateOpened( date );
      }}
    />
    )
  }
  return (
    <BackGroundGenerator isTLYF props={props}>
  
      <ImageBackground
            source={getImage('openflow.png')}
            style={{ width: '100%', height: 300, }}
            resizeMode={'cover'}
          >
        <ODSButton
        rIcon="TB-Arrow-Left"
        restStyle={{ marginTop: 20, marginLeft: 20, width: 200 }}
        type="secondary"
        disabled={false}
        onPress={() => popAction(props?.navigation)}
      >
        Go back
      </ODSButton>
          </ImageBackground>
      <View
        style={{
          width: layoutType === "web" ? 800 : "90%",
          alignSelf: "center",
          top:-230
        }}
      >
        <ReportsForm
          type={type}
          title={title}
          setTitle={setTitle}
          descriptionText={descriptionText}
          setDescriptionText={setDescriptionText}
          issueImages={issueImages}
          setIssueImages={setIssueImages}
          onSubmit={handleSubmit}
          showNodata={showNodata}
          renderFilePicker={RenderFileicper}
          renderRoomDropDown={renderRoomDropDown}
          renderCatogroriesDropDown={renderCatogroriesDropDown}
          renderDatePicker={RenderDatePicker}
        />
      </View>
    </BackGroundGenerator>
  );
};

export default ReportIssue;
